  export default `
    mutation createAnonymousCart($input:createAnonymousCartInput!) { 
    createAnonymousCart(input:$input){ 
        anonymous_cart_token
        }
    }
`;